export default "__VITE_ASSET__VLUuvZpP__"